<template>
  <img :src="qrcode" alt="" />
</template>
<script>
import qrcode from '../../../../assets/qrcode/qrcode.jpg';

export default {
  data() {
    return {
      qrcode
    };
  }
};
</script>
<style scoped>
img {
  width: 100%;
  padding: 0 0.16rem 0.16rem;
}
</style>
